import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';

import {
    createBrowserRouter,
    RouterProvider,
} from 'react-router-dom';

import Home from './Components/Home/Index';
import Login from './Components/Login/Index';
import Register from './Components/Register/Index';
import ForgotPassword from './Components/ForgotPassword/Index';
import MyFamily from './Components/FamilyTree/Index';
import AddFamilyTree from './Components/FamilyTree/Add';
import Appointment from './Components/Appointment/Index';
import WaitingRoom from './Components/WaitingRoom/Index';
import HealthRecord from './Components/HealthRecord/Index';
import HealthRecUpload from './Components/HealthRecord/HealthRecUpload';
import Prescription from './Components/Prescription/Index';
import MyCheckups from './Components/MyCheckups/Index';
import AllPackages from './Components/MyCheckups/AllPackages';
import BookCheckup from './Components/MyCheckups/BookCheckup';
import MyProfileFront from './Components/ProfileFront/Index';
import EditProfile from './Components/ProfileFront/Edit';
import Passport from './Components/Passport/Index';
import Search from './Components/DoctorListing/Index';
import SelectTimeSlot from './Components/SelectTimeSlot/Index';
import SelectLocation from './Components/SelectLocation/Index';
import ScheduleDetails from './Components/ScheduleDetails/Index';
import OnDemand from './Components/Ondemand/Index';
import HealthRecUploadOndemand from './Components/Ondemand/HealthRecUploadOndemand';
import PlanMySurgery from './Components/PlanMySurgery/Index';
import DeleteAccount from './Components/DeleteAccount/Index';
import EmailVerification from './Components/DeleteAccount/EmailVerification';
import AddProfile from './Components/Register/AddProfile';
import EditFamilyMember from './Components/FamilyTree/Edit';
import DoctorCampaign from './Components/DoctorCampaign';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        // errorElement: <Error />,
        children: [
            {
                path: '/',
                element: <Home />,
            },
            {
                path: '/login',
                element: <Login />,
            },
            {
                path: '/register',
                element: <Register />,
            },
            {
                path: '/forgotpassword',
                element: <ForgotPassword />,
            },
            {
                path: '/familytree',
                element: <MyFamily />,
            },
            {
                path: '/editfamily/:memberId',
                element: <EditFamilyMember />,
            },
            {
                path: '/addfamily',
                element: <AddFamilyTree />,
            },
            {
                path: '/appointment',
                element: <Appointment />,
            },
            {
                path: '/waitingroom',
                element: <WaitingRoom />,
            },
            {
                path: '/record',
                element: <HealthRecord />,
            },
            {
                path: '/healthrecupload',
                element: <HealthRecUpload />,
            },
            {
                path: '/prescription',
                element: <Prescription />,
            },
            {
                path: '/mycheckups',
                element: <MyCheckups />,
            },
            {
                path: '/allpackages',
                element: <AllPackages />,
            },
            {
                path: '/bookcheckup',
                element: <BookCheckup />,
            },
            {
                path: '/profilefront',
                element: <MyProfileFront />,
            },
            {
                path: '/profile',
                element: <EditProfile />,
            },
            {
                path: '/passport',
                element: <Passport />,
            },
            {
                path: '/online-doctors-consultation',
                element: <Search />,
            },
            {
                path: '/timeslot',
                element: <SelectTimeSlot />,
            },
            {
                path: '/selectloc',
                element: <SelectLocation />,
            },
            {
                path: '/scheduledetail',
                element: <ScheduleDetails />,
            },
            {
                path: '/newtimeslot',
                element: <OnDemand />,
            },
            {
                path: '/ondemandhealthrecupload',
                element: <HealthRecUploadOndemand />,
            },
            {
                path: '/plan-my-surgery',
                element: <PlanMySurgery />,
            },
            {
                path: '/delete-account',
                element: <DeleteAccount />,
            },
            {
                path: '/email-verification',
                element: <EmailVerification />,
            },
            {
                path: '/addprofile',
                element: <AddProfile />,
            },
            {
                path: '/online-doctors-consultations/:slug',
                element: <DoctorCampaign />,
            }

        ],
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
